import ReducerRegistry from "seneca-common/utils/state/reducer-registry";

import { PATH_TO_LOCATIONS_STATE } from "./consts";
import locationsReducer from "./reducers";

const reducerRegistry = ReducerRegistry.getInstance();
reducerRegistry.initialise(PATH_TO_LOCATIONS_STATE, builder => {
  builder.register(PATH_TO_LOCATIONS_STATE, locationsReducer);
});

export { locationsReducer, PATH_TO_LOCATIONS_STATE };

// selectors
export {
  getLocation,
  getLocations,
  makeGetRandomLocationsImageURLs,
  getLocationId,
  getLocationName,
  getLocationCountryName,
  getLocationImageUrl,
  getLocationLatitude,
  getLocationLongitude
} from "./selectors";
export {
  locationsAreFetching,
  locationsFetchSucceeded,
  locationsFetchErrored,
  locationsFetchFinished,
  locationsNeedFetching
} from "./selectors/meta";

// actions
export { receiveLocations } from "./actions";
export { fetchAllLocationsActionFactory } from "./actions/meta";

// models
export { default as Location } from "./models/state/locations/location/Location";
export type { LocationType } from "./models/state/locations/location/Location";
